__webpack_require__.p = "/genshin-tcg-cbir/";